/**
 * Quote-tool tracking decorator (TSE-731 — GA4 cross-domain attribution).
 *
 * Appends ad-click / attribution params (utm_*, gclid, and the other keys
 * captured by the irg_tracking cookie) to outbound newquotetool.irrigreen.com
 * URLs so ad-click context survives the cross-domain hop. Without this, every
 * quote-tool CTA drops the page's query string and the shared irg_tracking
 * cookie is the only surviving carrier.
 *
 * Two entry points:
 *   - window.irgAppendQuoteToolTracking(url) — used by JS that builds quote-tool
 *     URLs at click time (assets/quote-tool-redirect.js, sections/b2b-quotes.liquid).
 *   - automatic decoration of static <a href> quote-tool links on page load and
 *     on Theme Editor section re-render (home-hero, b2b-quote-tool-button,
 *     landing-page template button_url settings).
 *
 * Param sources, current page URL wins over the cookie fallback (which covers
 * internal navigations that dropped the query string several pages ago).
 */
(function (win, doc) {
  // Keep in sync with TRACKING_KEYS in layout/theme.liquid (source of truth).
  var TRACKING_KEYS = ['utm_', 'gclid', 'gbraid', 'wbraid', 'fbclid', 'source', 'ad_', 'adset_id', 'campaign', 'adset', 'placement'];
  var QUOTE_TOOL_HOST = 'newquotetool.irrigreen.com';

  function isTrackingKey(key) {
    return TRACKING_KEYS.some(function (k) {
      return key.indexOf(k) > -1;
    });
  }

  function readCookieLastTouch() {
    var m = doc.cookie.match(/(?:^|; )irg_tracking=([^;]*)/);
    if (!m) return {};
    try {
      var data = JSON.parse(decodeURIComponent(m[1]));
      return (data && data.lastTouch) || {};
    } catch (e) {
      return {};
    }
  }

  function readHubspotUtk() {
    var m = doc.cookie.match(/(?:^|; )hubspotutk=([^;]*)/);
    return m ? m[1] : null;
  }

  // Merge cookie last-touch (fallback) with current URL params (authoritative).
  function collectTrackingParams() {
    var params = {};
    var cookie = readCookieLastTouch();
    Object.keys(cookie).forEach(function (key) {
      if (isTrackingKey(key)) params[key] = cookie[key];
    });
    new URLSearchParams(win.location.search).forEach(function (value, key) {
      if (isTrackingKey(key)) params[key] = value;
    });
    return params;
  }

  function appendTracking(url) {
    if (!url || url.indexOf(QUOTE_TOOL_HOST) === -1) return url;
    var params = collectTrackingParams();
    var hutk = readHubspotUtk();
    if (hutk) params.hutk = hutk;
    var keys = Object.keys(params);
    if (!keys.length) return url;
    try {
      var u = new URL(url, win.location.origin);
      keys.forEach(function (key) {
        // Don't clobber params the URL already carries (e.g. B2B contractor ids).
        if (!u.searchParams.has(key)) u.searchParams.set(key, params[key]);
      });
      return u.toString();
    } catch (e) {
      return url;
    }
  }

  function decorateLinks(root) {
    var scope = root && root.querySelectorAll ? root : doc;
    var links = scope.querySelectorAll('a[href*="' + QUOTE_TOOL_HOST + '"]');
    Array.prototype.forEach.call(links, function (a) {
      a.href = appendTracking(a.getAttribute('href'));
    });
  }

  win.irgAppendQuoteToolTracking = appendTracking;

  function init() {
    decorateLinks(doc);
  }

  if (doc.readyState === 'loading') {
    doc.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Re-decorate links inside a section re-rendered by the Theme Editor.
  doc.addEventListener('shopify:section:load', function (e) {
    decorateLinks(e.target);
  });

  // Re-decorate at the moment of click too (capture phase, before navigation). The
  // DOMContentLoaded/section-load decoration above only reflects cookie state at render
  // time — hubspotutk in particular is set asynchronously by HubSpot's tracking script,
  // often after a static link (e.g. the homepage hero CTA) has already rendered. This
  // covers those static <a href> entry points; click-time-built URLs (quote-tool-redirect.js,
  // b2b-quotes.liquid) already call appendTracking themselves and are unaffected.
  doc.addEventListener(
    'click',
    function (e) {
      var a = e.target && e.target.closest && e.target.closest('a[href*="' + QUOTE_TOOL_HOST + '"]');
      if (!a) return;
      var decorated = appendTracking(a.getAttribute('href'));
      if (decorated) a.href = decorated;
    },
    true
  );
})(window, document);
